"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Close = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var Icon_styled_1 = require("../Icon.styled");
var common_styles_1 = require("@next-components/common-styles");
exports.Close = function (props) {
    return (React.createElement(Icon_styled_1.StyledSvg, tslib_1.__assign({}, props, { width: "17", height: "17", viewBox: "0 0 17 17", xmlns: "http://www.w3.org/2000/svg" }),
        React.createElement("path", { d: "M2 2L15 15", stroke: props.stroke || common_styles_1.black, strokeWidth: props.strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M2 15L15 2", stroke: props.stroke || common_styles_1.black, strokeWidth: props.strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" })));
};
//# sourceMappingURL=close.js.map